export const LINKEDIN_CONFIG = {
  clientId: '78ay9vxqvb5egt',
  clientSecret: 'WPL_AP1.BR2kgYQU6fUuLwiB.D56lLg==',
  redirectUri: window.location.origin + '/linkedin/callback',
  scope: 'r_liteprofile r_emailaddress',
  authUrl: 'https://www.linkedin.com/oauth/v2/authorization',
  tokenUrl: 'https://www.linkedin.com/oauth/v2/accessToken',
  apiBaseUrl: 'https://api.linkedin.com/v2'
};